import { defineStore } from "pinia";

import { getCompanyId } from "@/utils/userUtils";

import driversApi from "@/services/api/driversApi";

export const useDriverStore = defineStore("driver", {
  state: () => ({
    drivers: [],

    companyId: getCompanyId(),

    searchQuery: "",

    pagination: {
      page: 1,
      pages: 1,
      series: [],
      next: null,
      prev: null,
      count: 0,
      limit: 40,
    },

    dataIsLoading: false,
  }),

  actions: {
    async fetchDrivers(payload = {}) {
      this.searchQuery = payload.search || "";
      return await this.getDriversRequest(1);
    },

    async loadMoreDrivers() {
      if (this.dataIsLoading || !this.pagination.next) {
        return;
      }

      const nextPage = this.pagination.page + 1;
      return await this.getDriversRequest(nextPage);
    },

    async getDriversRequest(page) {
      const pageNumber = parseInt(page) || 1;

      try {
        this.dataIsLoading = true;

        const params = {
          page: pageNumber,
        };

        params["q[enabled]"] = "true";

        if (this.searchQuery) {
          params["q[search]"] = this.searchQuery;
        }

        const response = await driversApi.index(
          this.companyId,
          params
        );

        if (pageNumber === 1) {
          this.drivers = response.data.result;
        } else {
          this.drivers = [...this.drivers, ...response.data.result];
        }

        const meta = response.data.pagination_meta;
        this.pagination = {
          page: meta.page,
          pages: meta.pages,
          series: meta.series,
          next: meta.next,
          prev: meta.prev,
          count: meta.count,
          limit: meta.limit,
        };
      } catch (error) {
        console.error("Ошибка при загрузке водителей:", error);
      } finally {
        this.dataIsLoading = false;
      }
    },

    replaceDriver(driver) {
      if (!driver?.id) return;

      const index = this.drivers.findIndex(
        (item) => String(item.id) === String(driver.id)
      );

      if (index === -1) {
        this.drivers = [driver, ...this.drivers];
        return;
      }

      this.drivers.splice(index, 1, driver);
    },

    clearDrivers() {
      this.drivers = [];
      this.searchQuery = "";
      this.pagination = {
        page: 1,
        pages: 1,
        series: [],
        next: null,
        prev: null,
        count: 0,
        limit: 40,
      };
    },
  },
});
